import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  createRouter as createTanStackRouter,
  RouterProvider,
} from '@tanstack/react-router';
import { createRouter as createDatadogRouter } from '@datadog/browser-rum-react/tanstack-router';
import { routeTree } from './routeTree.gen';
import { ThemeProvider } from './components/ui/theme-provider';
import { datadogRumEnabled, envs } from './lib/constants';
import './translations/init-translations';

const queryClient = new QueryClient();

const createRouter = datadogRumEnabled
  ? createDatadogRouter
  : createTanStackRouter;

// Create a new router instance
const router = createRouter({
  routeTree,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const App = () => {
  return (
    <ThemeProvider
      defaultTheme={envs.ENVIRONMENT === 'development' ? 'system' : 'light'}
      storageKey='vite-ui-theme'
    >
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
